import secureUploadSession from '@/api/secure-upload/secureUploadSession'

export const secureUploadOTPRoute = {
  path: '/secure-upload',
  name: 'secure-upload',
  component: () =>
    import(/* webpackChunkName: "SecureUpload" */ '../../components/SecureUpload/SecureUploadVerifyForm.vue'),
  props: () => ({ isSecureUploadLogin: true }), // ✅ Use a function
  meta: { publicRoute: true },
  beforeEnter: (to, from, next) => {
    const token = window.localStorage.getItem('access_token')
    const expiresAt = window.localStorage.getItem('sessionExpiresAt')
    const secureMemberData = window.localStorage.getItem('secureMemberData')
    // If session is active and not expired, redirect to dashboard with valid id
    if (token && expiresAt && !secureUploadSession.isExpired(expiresAt) && secureMemberData) {
      try {
        const member = JSON.parse(secureMemberData)
        if (member && member.name) {
          next({ name: 'secure-upload-dashboard', params: { id: String(member.name) } })
          return
        }
      } catch (e) {
        // Ignore JSON parse errors, fallback to login
      }
    }
    next()
  },
}
